import React from 'react';
import { Grid, Box } from '@mui/material';
import TransformationBase from './common/TransformationBase';
import { TransformationHeading } from './common/fields/Heading';
import { COMMON_STYLES, COMMON_VALIDATION, COMMON_VALIDATION_PARAM } from './common/Constants';
import { SourceColumnField } from './common/fields/SourceColumnField';
import { OutputColumnField } from './common/fields/OutputColumnField';
import { CheckBoxField } from './common/fields/CheckBoxField';
import TransformationArrayField from './common/fields/TransformationArrayField';

const INITIALSTATE = {
  type: 'trunc_numbers',
  alias: '',
  df: '',
  transformations: [
    {
      sourceColumns: [''],
      outputColumn: '',
      param: 2,
      transformInPlace: false,
    },
  ],
};

const validationSchema = {
  ...COMMON_VALIDATION,
  ...COMMON_VALIDATION_PARAM('Enter number of decimal to keep'),
};

const renderTransformationFields = ({ formField, errors, setFieldValue, disableForm, headers }) => {
  const handleInPlaceChange = (index, value) => {
    const newTransforms = [...formField.transformations];
    newTransforms[index].transformInPlace = value;
    if (value) {
      newTransforms[index].outputColumn = '';
    }
    setFieldValue('transformations', newTransforms);
  };

  const renderField = ({ transform, index, headers, disableForm, errors }) => {
    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CheckBoxField
              checked={transform.transformInPlace}
              onChange={(value) => handleInPlaceChange(index, value)}
              disabled={disableForm}
            />
          </Grid>

          <Grid item {...COMMON_STYLES.gridItem}>
            <SourceColumnField
              helperText={
                errors?.sourceColumns || 
                (transform.transformInPlace
                  ? 'This column will be truncated directly'
                  : 'Select numeric column to truncate')
              }
              value={transform.sourceColumns?.[0] || ''}
              onChange={(e) => {
                const newTransforms = [...formField.transformations];
                newTransforms[index].sourceColumns = [e.target.value];
                setFieldValue('transformations', newTransforms);
              }}
              headers={headers}
              disabled={disableForm}
              error={!!errors.sourceColumns}
            />
          </Grid>
          <Grid item {...COMMON_STYLES.gridItem}>
            <OutputColumnField
              value={transform.param}
               onChange={(e) => {
                const value = e.target.value;
                if (/^[1-9]\d*$/.test(value) || value === '') {
                  const newTransforms = [...formField.transformations];
                newTransforms[index].param = value;
                setFieldValue('transformations', newTransforms);
                }
              }}
              disabled={disableForm}
              label="Decimal Places *"
              type="number"
              helperText={errors?.param || "Number of decimal places to keep (Positive integer)"}
              error={!!errors.param}
            />
          </Grid>

          {!transform.transformInPlace && (
            <Grid item {...COMMON_STYLES.gridItem}>
              <OutputColumnField
                value={transform.outputColumn}
                onChange={(e) => {
                  const newTransforms = [...formField.transformations];
                  newTransforms[index].outputColumn = e.target.value;
                  setFieldValue('transformations', newTransforms);
                }}
                disabled={disableForm}
                error={!!errors?.outputColumn}
                helperText={errors?.outputColumn || 'Enter output column name'}
              />
            </Grid>
          )}
        </Grid>
      </>
    );
  };
  return (
    <Box sx={COMMON_STYLES.container}>
      <TransformationHeading title="Trim Number - Remove decimal places (3.99 → 3)" disabled={disableForm} />
      <TransformationArrayField
        transformations={formField.transformations}
        setTransformations={(newTransforms) => setFieldValue('transformations', newTransforms)}
        renderField={renderField}
        errors={errors.transformations || []}
        headers={headers}
        disableForm={disableForm}
      />
    </Box>
  );
};

const NodeModal_TruncNumbers = (props) => (
  <TransformationBase
    {...props}
    INITIALSTATE={INITIALSTATE}
    validationSchema={validationSchema}
    renderTransformationFields={renderTransformationFields}
    transformationType={INITIALSTATE.type}
    tranformationName="Trim Number"
  />
);

export default NodeModal_TruncNumbers;
